export default {
  'forms.save_status_checks.authentication.api_base_url.text_field.label':
    'API Base URL',
  'forms.save_status_checks.authentication.header.label': 'Authentication',
  'forms.save_status_checks.authentication.authentication_url.prompt':
    'What URL should Gremlin use to authenticate this observability tool?',
  'forms.save_status_checks.authentication.authentication_url_aws.prompt':
    'What endpoint should we test your credentials against?',
  'forms.save_status_checks.authentication.authentication_url.text_field.label':
    'Authentication Endpoint',
  'forms.save_status_checks.authentication.aws.prompt':
    'What are the AWS credentials?',
  'forms.save_status_checks.authentication.aws.add_new_account.text_field.label':
    'Add a new account ID',
  'forms.save_status_checks.authentication.aws.aws_account_id.text_field.label':
    'AWS Account ID',
  'forms.save_status_checks.authentication.aws.aws_access_key_id.text_field.label':
    'AWS Access Key ID',
  'forms.save_status_checks.authentication.aws.aws_secret_access_key.text_field.label':
    'AWS Secret Access Key',
  'forms.save_status_checks.authentication.headers.prompt':
    'What are the authentication key and header values Gremlin should use to authenticate this observability tool?',
  'forms.save_status_check.connect_monitor.status_check_name.prompt':
    'What is the name of this Health Check?',
  'forms.save_status_check.connect_monitor.status_check_name.text_field.label':
    'Health Check Name',
  'forms.save_status_check.connect_monitor.monitor_url.prompt':
    'What monitor or alert will help Gremlin determine the health of your Service?',
  'forms.save_status_check.connect_monitor.monitor_url.radio.label':
    'Datadog monitor URL',
  'forms.save_status_check.connect_monitor.monitor_search.radio.label':
    'Search for Datadog monitor by name',
  'forms.save_status_check.connect_monitor.monitor_url.text_field.label':
    'Monitor or Alert URL',
  'forms.save_status_check.connect_monitor.monitor_url_aws_cloudwatch.text_field.label':
    'Create a Health Check from an AWS Cloudwatch Alarm URL',
  'forms.save_status_check.connect_monitor.monitor_url_aws_api.text_field.label':
    'Create a Health Check from AWS API',
  'forms.save_status_check.connect_monitor.success_evaluation.header.label':
    'Success Evaluation',
  'forms.save_status_check.connect_monitor.success_evaluation.subheader.label':
    'This criteria will tell us if the target or service is weathering the tests.',
  'forms.save_status_check.connect_monitor.success_evaluation.healthy_status_code.text_field.label':
    'Healthy Status Code',
  'forms.save_status_check.connect_monitor.success_evaluation.healthy_status_code.text_field.helper_text':
    'Add a single code or a range; e.g. 200-299',
  'forms.save_status_check.connect_monitor.success_evaluation.request_timeout.text_field.label':
    'Request Timeout',
  'forms.save_status_check.connect_monitor.success_evaluation.request_timeout.text_field.helper_text':
    'Maximum time in milliseconds to wait for a response',
  'forms.save_status_check.select_observability_tool_and_domain.observability_tool.prompt':
    'What observability tool will your team be using?',
  'forms.save_status_check.select_observability_tool_and_domain.observability_tool_aws_account_id.prompt':
    'What AWS Account ID will be used?',
  'forms.save_status_check.select_observability_tool_and_domain.observability_tool.select_field.label':
    'Observability Tool',
  'forms.save_status_check.select_observability_tool_and_domain.observability_tool.custom.list_subheader.label':
    'Custom Observability Tools',
  'forms.save_status_check.select_observability_tool_and_domain.domain.select_field.label':
    'Domain',
  'forms.save_status_checks.observability_tool_headers.key.text_field.label':
    'Key',
  'forms.save_status_checks.observability_tool_headers.value.text_field.label':
    'Value',
  'form.save_status_checks.predicate_configuration.key.text_field.label': 'Key',
  'form.save_status_checks.predicate_configuration.key.text_field.helper_text':
    'Key from response body',
  'form.save_status_checks.predicate_configuration.type.text_field.label':
    'Key Type',
  'form.save_status_checks.predicate_configuration.comparator.text_field.label':
    'Comparator',
  'form.save_status_checks.predicate_configuration.value.text_field.label':
    'Value',
  'form.save_status_checks.predicate_configuration.value.text_field.helper_text':
    'Success Value from response body',
  'forms.save_status_checks.custom_observability_tool_options.observability_tool_name.prompt':
    'In the future, what name should your team see as the name of this observability tool definition?',
  'forms.save_status_checks.custom_observability_tool_options.observability_tool_name.text_field.label':
    'Observability Tool Nickname',
  'forms.save_status_checks.custom_observability_tool_options.multiple_regions.prompt':
    'Does this observability tool have multiple regions?',
  'forms.save_status_checks.custom_observability_tool_options.multiple_regions.custom_domain_name.text_field.label':
    'Domain Name',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.prompt':
    'Is this observability tool behind a firewall or on-prem?',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.alert.line_1.text':
    'You will need to install a ',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.alert.link.text':
    'private network integration agent',
  'forms.save_status_checks.custom_observability_tool_options.is_private_network.alert.error.text':
    'There was an error when checking for a',
  'forms.save_status_checks.monitor_url.existing_status_check.link.text':
    'Go to existing Health Check'
}
